module.exports = __webpack_public_path__ + "img/Chevron-Right_24px_disable_light.3c91a8bb.svg";